import { dispensaryDashboardSlice } from '../slices/dispensaryDashboardSlice';

export default dispensaryDashboardSlice.reducer;
